"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUES = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
exports.DEFAULT_VALUES = Object.freeze({
    br: (0, jsx_runtime_1.jsx)("br", {}),
    p: (chunks) => (0, jsx_runtime_1.jsx)("p", { children: chunks }),
    strong: (chunks) => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
    span: (chunks) => (0, jsx_runtime_1.jsx)("span", { children: chunks })
});
//# sourceMappingURL=values.js.map